import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMarketingPlanList extends Layout {
    layoutheaderCarrierActivityList: LayoutHeader;
    sourceMarketPlan: DataSource;
    tableMarketingPlan: Table;
}
